import React, { Fragment, Component } from 'react'
import firebase from '../../firebase'

import manutenzione from '../../img/manutenzione.png'

import LayoutOrizzontale from '../../components/sito/temi/layoutorizzontale'

class Professionista extends Component {
	constructor(props) {
		super(props)
		this.state = {
			sito: {},
			account: {},
			loading: true
		}
	}

	componentDidMount() {

		const posizione = this.props.location.search.substr(6).indexOf('&')

		let userId = ""

		if (posizione > -1) {
			userId = this.props.location.search.substr(6, posizione)
		} else {
			userId = this.props.location.search.substr(6)
		}

		firebase.database().ref().child('account/' + userId).on('value', snapshot => {
			snapshot.val() !== null && this.setState({ account: snapshot.val() })
			snapshot.val() !== null && firebase.database().ref().child('sito/' + userId)
				.on('value', sito => {
					this.setState({ sito: sito.val(), loading: false })

				});
		})
	}

	render() {

		return (

			<Fragment>
				{!this.state.loading ?

					<Fragment>
						{this.state.sito === null ?
							<section className="uk-section uk-section-large">
								<div className="uk-flex uk-flex-center uk-margin">
									<img src={manutenzione} style={{ maxWidth: '300px' }} />
								</div>
								<h1 className="uk-heading-medium uk-text-center">Sito in manutenzione</h1>
							</section>

							:
							<LayoutOrizzontale user={this.state.account} sito={this.state.sito} />
						}
					</Fragment>

					:

					<div className="uk-position-center">
						<div className="loadr" />
						<div className="loadr" />
					</div>

				}
			</Fragment>

		)
	}
}

export default Professionista


// WEBPACK FOOTER //
// ./src/pages/professionista/index.js